import type { FieldsConfiguration } from '@molecules/Field/Field.types'
import { useIntl, defineMessages } from 'react-intl'

export const messages = defineMessages({
  activationCode: {
    defaultMessage: 'Activation Code',
    id: 'msp.git_card_form.code'
  },
  button: {
    defaultMessage: 'Check',
    id: 'msp.git_card_check_form.button'
  }
})

const getGiftCardCheckFields = (): FieldsConfiguration => {
  const { formatMessage } = useIntl()

  return {
    activationCode: {
      id: 'activationCode',
      type: 'text',
      name: 'activationCode',
      placeholder: '',
      label: formatMessage(messages.activationCode),
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter the Activation Code.',
          id: 'msp.gift_card_check_form.error.code'
        })
      }
    }
  }
}

export default getGiftCardCheckFields
